export const viewMoreFeatures = (widget: HTMLElement): void => {
  widget.classList.add('active')
}

export const viewLessFeatures = (widget: HTMLElement): void => {
  widget.classList.remove('active')
}
